<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Declaración de Accesibilidad</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page">
            <section class="section">
                <header class="lcu-section-header lcu-center-text">
                Declaración De Accesibilidad
                </header>
            </section>
            <section class="section">
                <p>
                    <strong>Compromiso Con La Accesibilidad</strong>
                </p>
                <p>
                    Nuestro objetivo es proporcionar aprendizaje flexible y eficaz,
                    así como desarrollo de habilidades, tanto a organizaciones como
                    a individuos. Creemos que el contenido educativo de alta calidad
                    debe estar disponible para todos; por ello, la accesibilidad es
                    un área clave de enfoque para nosotros.
                </p>
                <p>
                    Trabajamos de manera constante para mejorar la accesibilidad de
                    nuestros servicios. A continuación, presentamos algunos ejemplos
                    de cómo estamos construyendo una plataforma más accesible:
                </p>

                <ul>
                    <li class="lcu-acc-bullet">
                        <strong>Pautas de accesibilidad</strong>. Nos esforzamos por cumplir con
                        el estándar 2.1 de las Pautas de Accesibilidad al Contenido Web (WCAG),
                        emitidas por el Consorcio World Wide Web (W3C), y utilizamos la
                        especificación de Aplicaciones de Internet Enriquecidas Accesibles
                        (WAI-ARIA). Evaluamos nuestro sitio web y aplicaciones móviles utilizando
                        la versión internacional del estándar Voluntary Product Accessibility
                        Template (VPAT).
                    </li>
                    <li class="lcu-acc-bullet">
                        <strong>Pruebas de compatibilidad</strong>. Probamos nuestro sitio web
                        y aplicaciones móviles para asegurar su
                        compatibilidad con múltiples lectores de pantalla y herramientas de
                        accesibilidad, tales como NonVisual Desktop Access (NVDA), Job Access with
                        Speech (JAWS®), VoiceOver para los sistemas operativos macOS e iOS, y
                        TalkBack para Android.
                    </li>
                    <li class="lcu-acc-bullet">
                        <strong>Configuraciones de video</strong>. Nuestro reproductor de
                        video incluye diversas funciones y configuraciones que
                        permiten a los estudiantes mejorar su experiencia de aprendizaje.
                        Los atajos de teclado en nuestras aplicaciones pueden utilizarse
                        para ajustar diferentes opciones de video.
                    </li>
                    <li class="lcu-acc-bullet">
                        <strong>Sistema de diseño</strong>. La accesibilidad es un principio
                        central de nuestro sistema interno de diseño. Nuestros ingenieros y
                        diseñadores trabajan junto con consultores especializados
                        en accesibilidad para implementar mejoras continuas en dicho sistema.
                    </li>
                    <li class="lcu-acc-bullet">
                        <strong>Investigación continua</strong>. Colaboramos con consultores
                        en accesibilidad para auditar nuestros servicios y
                        proporcionar recomendaciones que nos permitan mejorar constantemente la
                        accesibilidad de nuestra plataforma.
                    </li>
                </ul>
                <p>
                    <strong>Asistencia En Accesibilidad</strong>
                </p>
                <p>
                    Si tiene alguna dificultad para usar o acceder a las aplicaciones de
                    Legacy Christian University, o si tiene sugerencias sobre cómo podemos
                    mejorar la accesibilidad de nuestros servicios, le invitamos a comunicarse
                    con nosotros por correo electrónico a: legacychristianuniversityapp@gmail.com
                </p>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';

export default {
  name: 'accessibility-statement-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    Footer,
    MobileControls,
    IphoneBar,
    SecondaryNav,
  },
};
</script>

<style scoped lang="scss">
.lcu-acc-bullet {
  margin-bottom: 15px;
}
</style>
